import PropTypes from 'prop-types';
import BaseMenuItem from './BaseMenuItem';

const MenuItem = ({
                    icon,
                    label,
                    onClick,
                    isLoading,
                    isSuccess,
                    isFailed,
                  }) => {
  return <BaseMenuItem
    icon={icon}
    label={label}
    onClick={onClick}
    isLoading={isLoading}
    isSuccess={isSuccess}
    isFailed={isFailed}
  />;
};

MenuItem.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.element.isRequired,
  onClick: PropTypes.func,
};

export default MenuItem;
